import { EventEmitter, Injectable, Output } from '@angular/core';
import { NavigationLink } from '@zipari/shared-ds-util-navigation';

@Injectable({
  providedIn: 'root',
})
export class NavIconsService {
  @Output() navItemClicked = new EventEmitter<NavigationLink>();
  @Output() navMenuToggled = new EventEmitter<NavigationLink>();

  onIconClick(icon: NavigationLink): void {
    this.navItemClicked.emit(icon);
  }

  onNavMenuToggle(icon: NavigationLink): void {
    this.navMenuToggled.emit(icon);
  }
}
